import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigurationService } from './configuration.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { DriftConfiguration } from '../models/configuration.interface';
import { User } from '../models/user.interface';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  config: DriftConfiguration;

  constructor(
    private http: HttpClient,
    private configurationService: ConfigurationService
  ) {
    this.config = this.configurationService.getConfiguration();
  }

  public addOrUpdateUser(email: string, isAdmin: boolean): Observable<string> {
    const params = new HttpParams().set('email', email).set('is_admin', isAdmin.toString());
    return this.http.post<string>(`${this.config.driftApi}/users`, null, { params });
  }

  public deleteUser(email: string): Observable<string> {
    const params = new HttpParams().set('email', email);
    return this.http.delete<string>(`${this.config.driftApi}/users`, { params });
  }

  public getUsers(): Observable<User[]> {
    return this.http.get<User[]>(`${this.config.driftApi}/users`);
  }
}
